import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@govtechsg/sgds-react/Button";
//import { Container, Footer } from '@govtechsg/sgds-react'
import { Helmet } from "react-helmet-async";
import { getUrlParam } from "./helper";

// Components
import HeaderRegComponent from "../Components/HeaderRegComponent";
import FooterComponent from "../Components/FooterComponent";

// Images
import successImg from "../assets/icons/regSuccess.svg";

const ResetPasswordSuccess = () => {
  const location = useLocation();
  // const navigate = useNavigate()

  const [accessToken, setAccessToken] = useState("");
  const [expiry, setExpiry] = useState("");
  const [copySuccess, setCopySuccess] = useState("Copy");

  const copyToken = (e) => {
    try {
      navigator.clipboard.writeText(accessToken);
      setCopySuccess("Copied");
      setTimeout(() => {
        setCopySuccess("Copy");
      }, 2000);
    } catch (err) {
      setCopySuccess("Copy");
    }
  };

  useEffect(() => {
    try {
      if (
        location &&
        location.state &&
        location.state.accessToken &&
        location.state.expiry_timestamp
      ) {
        let convertedDate = new Date(location.state.expiry_timestamp * 1000);

        setExpiry(convertedDate.toDateString());

        setAccessToken(location.state.accessToken);
      } else {
        const expiry_timestampLocal = new Date(
          parseInt(getUrlParam("expiry_timestamp")) * 1000,
        );

        setExpiry(expiry_timestampLocal.toDateString());
        setAccessToken(getUrlParam("accessToken"));
      }
    } catch (error) {
      // console.log("ERROR", error);
      setExpiry("");
      setAccessToken("");
    }

    /*
		if(!accessToken || accessToken.length === 0 ||
			!expiry || expiry.length === 0)
		{
			navigate(`${process.env.REACT_APP_PUBLIC_URL}/forgetpassword`);
		}
		*/
  }, []);
  return (
    <>
      <Helmet>
        <title>Reset Your OneMap API Password | OneMap API</title>
        <meta
          name="description"
          content="Recover access to your OneMap API account by resetting your password. Enter your email and receive instructions to create a new password securely."
        />
      </Helmet>
      <div className="om-body container-fluid">
        <HeaderRegComponent />

        <div className="om-body-content pageBase">
          <div id="om-section-reg-success" className="om-sections">
            <div className="center om-body-container text-center">
              <div className="row mb-4">
                <div>
                  <img className="om-icw42" src={successImg} alt="successImg" />
                </div>

                <h1>Password Reset Successful!</h1>
              </div>

              <div className="row mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center om-highlight-toolbar border-bottom">
                      <small className="text-body-secondary">
                        Access Token
                      </small>
                      <div className="d-flex ms-auto">
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm om-btn-capsult"
                          onClick={copyToken}
                        >
                          {copySuccess}
                        </button>
                      </div>
                    </div>

                    <div className="om-highlight token">
                      <small
                        id="om-access-token"
                        className="text-body-secondary"
                      >
                        {accessToken}
                      </small>
                    </div>

                    <div className="d-flex align-items-center om-highlight-toolbar border-top">
                      <small className="text-body-secondary">
                        Token expires on: {expiry}
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="inline-block text-center">
                  <Link to={`/`}>
                    <Button className="om-btn-form-submit om-red">
                      Back To Home
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FooterComponent />
      </div>
    </>
  );
};

export default ResetPasswordSuccess;
